import React from "react";
import '../../components/Category/Category.css';
import '../../styles/CustomClassCss/Custom.css';
import steel1 from '../../assets/images/steel1.png';
import polymer1 from '../../assets/images/polymer2 copy.webp';

const Category = () => {
  return (
    <div className="category-container  gray-background  custom-inner-space custom-container-upper">
      <h2 className="category-title font-merriweather">View our categories</h2>
      <p className="category-description font-poppins">
        STELMART primarily specializes in two product categories: Steel products and Polymer products.
      </p>
      <div className="category-flex">
        <div className="category-section steel-section">
          <div className="steel-image-container">
            <img src={steel1} alt="Steel" className="overlay-image" />
            <h3 className="category-name">Steel</h3>
            <p>High-quality steel products sourced for strength and durability in every project.</p>
          </div>
        </div>

        <div className="category-section polymer-section">
          <div className="polymer-image-container">
            <img src={polymer1} alt="Polymer" className="overlay-image" />
            <h3 className="category-name">Polymer</h3>
            <p>Premium polymer solutions engineered for flexibility and long-lasting performance.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Category;
